import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function H() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('wave2portableairconditioner');

    // useEffect(() => {
    //     const layoutH = typeof window === 'undefined' ? 1080 : window?.innerHeight;
    //     AniContainer.create({
    //         asyncFromTo: [
    //             // [`.wave2-detail-I .title-text`, { opacity: 1, y: 0 }, { opacity: 0, y: -80 }, 4], // 文案上移淡出
    //             // ['.wave2-detail-E .ani-wrapper-2', { opacity: 1, y: 0 }, { opacity: 0, y: -layoutH }, 0], // 视频上移淡出
    //             ['.wave2-detail-H .img-wrapper', {  opacity: 0 }, {  opacity: 1 }, 1], // 背景图放大淡入
    //             // ['.wave2-detail-H .text-wrapper', { opacity: 0, y: 200 }, { opacity: 1, y: 0 }, 1], // 描述文案移上来且淡入
    //         ],
    //         // asyncTimeLine: [0, 1],
    //         triggerElement: '.wave2-detail-H',
    //         triggerHook: 1,
    //         offset: layoutH,
    //         duration: '50%',
    //     });
    // });

    return (
        <div className={`wave2-detail-H ${css.wave2DetailH}`}>
            <div className="viewport-wrapper">
                <div className="img-wrapper">
                    <NextImage
                        webpSrc={require('@publicLocal/wave2/detail/pc/section_h.webp')}
                        src={require('@publicLocal/wave2/detail/pc/section_h.jpg')}
                        alt={t('detail.sectionB_3')}
                        aria-label={t('detail.sectionB_3')}
                    />
                </div>
                <div className="text-wrapper">
                    <div className="left">
                        <p className="text1">
                            {t.rich('detail.sectionH_1', {
                                line1: (text1: any) => <span className="line1">{text1}</span>,
                            })}
                        </p>
                        <p className="text2">{t('detail.sectionH_2')}</p>
                    </div>
                    {locale !== 'cn' && (
                        <div className="right">
                            {locale === 'kr' && <p className="text2">{t('detail.sectionH_4_1')}</p>}
                            <p className="text1">{t('detail.sectionH_3')}</p>
                            <p className="text2">{t('detail.sectionH_4')}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
